'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { IconLoader2 } from '@tabler/icons-react';

// Types
import { LoaderIconProps } from './types';

// Style
import * as classes from './styles/index.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function LoaderIcon({ loading = true, ...iconProps }: LoaderIconProps) {
  /* ********************************** HOOKS ********************************* */

  /* ******************************** RENDERING ******************************* */
  return loading ? (
    <IconLoader2 className={classes.inProgressIcon} {...iconProps} />
  ) : null;
}

export default LoaderIcon;
